import React from 'react';
import { Card, StyledIcon } from './styles';
import {
  FiBarChart2,
  FiChevronsDown,
  FiCopy,
  FiEye,
  FiFileText,
  FiPrinter,
  FiSettings,
} from 'react-icons/fi';
import { useAuth } from '../../context/AuthContext';

interface CardGerencialProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: 'report' | 'graph';
  title: string;
  description: string;
  showSettings: boolean;
  onHeaderIconClick?: () => void;
  onSettingsIconClick?: () => void;
  onExcelIconClick?: () => void;
}

const renderHeaderIcon = (variant?: string) => {
  if (variant === 'report') {
    return <FiFileText />;
  }

  if (variant === 'graph') {
    return <FiBarChart2 />;
  }

  return <FiCopy />;
};

const renderFooterIcon = (variant?: string, onHeaderIconClick?: () => void) => {
  if (variant === 'report') {
    return <FiPrinter className="medium-icon" onClick={onHeaderIconClick} />;
  }

  if (variant === 'graph') {
    return <FiEye className="medium-icon" onClick={onHeaderIconClick} />;
  }

  return <FiChevronsDown />;
};

export const CardGerencial: React.FC<CardGerencialProps> = ({
  variant,
  description,
  title,
  showSettings,
  onHeaderIconClick,
  onSettingsIconClick,
  onExcelIconClick,
  ...props
}) => {
  const { verifyAccess } = useAuth();
  const haveSettings =
    verifyAccess('VISUALIZAR CAMPOS DO RELATÓRIO DE PACIENTES') && showSettings;

  return (
    <Card variant={variant} haveSettings={haveSettings} {...props}>
      <div>{renderHeaderIcon(variant)}</div>
      <div>
        <h2>{title}</h2>
        <p>{description}</p>
      </div>
      <div>
        {haveSettings && (
          <FiSettings className="small-icon" onClick={onSettingsIconClick} />
        )}

        {haveSettings && (
          <StyledIcon
            variant={variant}
            className="small-icon"
            onClick={onExcelIconClick}
          />
        )}

        {renderFooterIcon(variant, onHeaderIconClick)}
      </div>
    </Card>
  );
};
